import IIconProps from "../type";

const IconMolber = ({
  width,
  height,
  color = "#000000",
  ...props
}: IIconProps) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      width={width}
      height={height}
      {...props}
    >
      <g>
        <g>
          <path
            d="M420.998,301.996H91.003c-16.569,0-30,13.431-30,30c0,16.567,13.431,30,30,30h58.411l-45.521,112.41 c-4.785,13.927,1.882,29.312,15.558,35.242c15.233,6.606,32.772-1.258,38.127-16.829l16.293-40.824h164.255l16.296,40.824 c5.61,16.331,24.408,23.954,39.826,16.027c12.651-6.504,18.4-21.218,13.859-34.44l-45.579-112.41h58.47c16.569,0,30-13.433,30-30 C450.998,315.427,437.567,301.996,420.998,301.996z M185.844,421.994l23.945-59.999h92.412l23.95,59.999H185.844z"
            fill={color}
          ></path>
        </g>
      </g>
      <g>
        <g>
          <path
            d="M375.999,59.999H136.002c-24.814,0-44.999,20.186-44.999,44.999v166.998h329.995V104.999 C420.998,80.185,400.812,59.999,375.999,59.999z"
            fill={color}
          ></path>
        </g>
      </g>
      <g>
        <g>
          <path
            d="M256,0c-19.53,0-36.023,12.578-42.236,30h84.473C292.024,12.578,275.53,0,256,0z"
            fill={color}
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default IconMolber;
